import { Modal } from "@common/Modal/Modal";
import { Button, Grid, Typography } from "@material-ui/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IUserDetailsInfo } from "../interface/IUserDetails";
import UpdateUserIdentity from "./UpdateUserIdentity";

interface IParams {
    userDetails: IUserDetailsInfo | undefined;
    getUserDetails: () => void;
}

const UserIdentification = (props: IParams) => {
    const { userDetails, getUserDetails } = props;
    const [isEditing, setIsEditing] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { t } = useTranslation("profile");

    const onFinishUpdate = () => {
        setIsEditing(false);
        setIsModalOpen(true);
        getUserDetails();
    };

    const closeModal = () => setIsModalOpen(false);

    return (
        <>
            <Modal
                close={closeModal}
                confirm={closeModal}
                content={t("updatePersonalDetailsSuccess")}
                isModalOpen={isModalOpen}
                title={t("updatePersonalDetails")}
            />
            <Grid alignItems="center" className="mydetail__fields" container spacing={1} item>
                <Grid item sm={4} xs={12}>
                    <Grid className="mydetail__fields" container direction="column" spacing={1}>
                        <Grid item xs={12}>
                            <Typography color="textSecondary" id="detailName" variant="body2">
                                {t("name")}
                            </Typography>
                            <Typography aria-labelledby="detailName" variant="body1">
                                {userDetails ? `${userDetails.firstName} ${userDetails.lastName}` : ""}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography color="textSecondary" id="idNum" variant="body2">
                                {t("idNumber")}
                            </Typography>
                            <Typography aria-labelledby="idNum" variant="body1">
                                {userDetails?.identityDocument}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item sm={8} xs={12}>
                    <Button
                        disabled={!userDetails?.canEditIdentityDocument}
                        color="secondary"
                        size="large"
                        type="button"
                        variant="contained"
                        onClick={() => setIsEditing(true)}
                    >
                        {t("updatePersonalDetails")}
                    </Button>
                </Grid>
            </Grid>
            {isEditing && (
                <UpdateUserIdentity handleCancelClick={() => setIsEditing(false)} onFinishUpdate={onFinishUpdate} />
            )}
        </>
    );
};

export default UserIdentification;
